// sav-load-more-history.js
// Wraps every <xo-filters-load-more> on the page so clicking it updates the
// URL (Wave's own component never does), and full-reloads on back/forward
// so the browser's native scroll restoration applies. This does NOT wrap or
// reassign history.pushState/replaceState (a different section's script
// does that, safely, by capturing-and-delegating) — this script only ever
// CALLS history.pushState normally, which composes correctly regardless of
// script load order.
(function () {
  "use strict";

  function currentPage() {
    var p = parseInt(new URLSearchParams(location.search).get("page"), 10);
    return p > 0 ? p : 1;
  }

  function waitForGridUpdate(cb) {
    var target = document.querySelector(".section-collection-products, [xo-main-collection]");
    if (!target) { cb(); return; }
    var done = false;
    var obs = new MutationObserver(function () {
      if (done) return;
      done = true;
      obs.disconnect();
      cb();
    });
    obs.observe(target, { childList: true, subtree: true });
    setTimeout(function () {
      if (!done) { done = true; obs.disconnect(); cb(); }
    }, 4000);
  }

  function wireLoadMore(el) {
    if (el.dataset.savHistoryWired) return;
    el.dataset.savHistoryWired = "true";

    var page = currentPage();
    var button = el.querySelector("button, a");
    if (!button) return;

    button.addEventListener("click", function () {
      waitForGridUpdate(function () {
        page += 1;
        var url = new URL(location.href);
        url.searchParams.set("page", String(page));
        history.pushState({ savLoadMorePage: page }, "", url.toString());
        lastKey = pageKey();
        lastHash = location.hash;
      });
    }, { capture: true });
  }

  document.querySelectorAll("xo-filters-load-more").forEach(wireLoadMore);

  // Wave's facet filtering re-renders the grid (and can re-render the
  // load-more button itself) without a full page navigation, so keep
  // watching for new instances rather than wiring once at load.
  var bodyObserver = new MutationObserver(function () {
    document.querySelectorAll("xo-filters-load-more").forEach(wireLoadMore);
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });

  // Back/forward full-reloads so load-more pages and filters restore properly. A same-page
  // anchor link ("#compare", "#shop") also fires popstate, and reloading there turned every
  // "jump to section" button into a page reload, so skip hash-only steps: same path and query
  // as before, with a #hash on either side of the step.
  function pageKey() { return location.pathname + location.search; }
  var lastKey = pageKey();
  var lastHash = location.hash;

  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest("a[href*='#']") : null;
    if (a) { lastKey = pageKey(); lastHash = location.hash; }
  }, true);

  window.addEventListener("popstate", function () {
    var hashOnly = pageKey() === lastKey && (location.hash !== "" || lastHash !== "");
    lastKey = pageKey();
    lastHash = location.hash;
    if (hashOnly) return;
    location.reload();
  });

  // Some jump buttons link to a section's template key ("#shop_head") rather than an element
  // id. Shopify renders that section as id="shopify-section-template--<n>__shop_head", so when
  // no element carries the bare id, resolve the key to its section and scroll there.
  function sectionFor(id) {
    if (!id || document.getElementById(id)) return null;
    try {
      return document.querySelector('[id^="shopify-section-"][id$="__' + CSS.escape(id) + '"]');
    } catch (err) { return null; }
  }

  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest("a[href*='#']") : null;
    if (!a) return;
    var url = new URL(a.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search) return;
    var el = sectionFor(decodeURIComponent(url.hash.slice(1)));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  if (location.hash) {
    var arrived = sectionFor(decodeURIComponent(location.hash.slice(1)));
    if (arrived) arrived.scrollIntoView();
  }
})();
